// src/lib/sanity.ts
import { createClient } from '@sanity/client'
import { DEFAULT_ISLAND_KEY } from 'alakai-aloha-shared';
import { getRuntimeSiteContext } from './siteContext';

export const sanityClient = createClient({
  projectId: '8nyoc58q',   
  dataset: 'production',          // or whatever you called your dataset
  apiVersion: '2023-04-01',       // stable API version
  useCdn: true,                   // enables cached fast responses (good for read-only)
})

export const DEFAULT_SANITY_ISLAND = DEFAULT_ISLAND_KEY;

export function getCurrentSanityIsland() {
  return getRuntimeSiteContext().island || DEFAULT_SANITY_ISLAND;
}

export function withCurrentIslandParam(params = {}) {
  return {
    ...params,
    island: params?.island || getCurrentSanityIsland(),
  };
}

export function islandScopedDocumentFilter(field = 'island') {
  return `((!defined(${field}) && $island == "${DEFAULT_SANITY_ISLAND}") || ${field} == $island)`;
}

export function islandApplicableDocumentFilter(field = 'islands') {
  return `((!defined(${field}) && $island == "${DEFAULT_SANITY_ISLAND}") || $island in ${field})`;
}

export async function sanityFetch(query, params = {}) {
  return sanityClient.fetch(query, withCurrentIslandParam(params));
}
